import {ActionType} from 'redux/actions/beneficiariesActionTypes';
import {BeneficiariesPaperwork, Beneficiary, Paperwork} from 'lib/entities';

export function addBeneficiary(contingent: boolean) {
    return {
        type: ActionType.BENEFICIARIES_ADD,
        payload: contingent,
    };
}

export function cancelAddBeneficiary(id: string) {
    return {
        type: ActionType.BENEFICIARIES_CANCEL_ADD,
        payload: id,
    };
}

export function editBeneficiary(id: string) {
    return {
        type: ActionType.BENEFICIARIES_EDIT,
        payload: id,
    };
}

export function cancelEditBeneficiary(id: string) {
    return {
        type: ActionType.BENEFICIARIES_CANCEL_EDIT,
        payload: id,
    };
}

export function saveBeneficiary(beneficiary: Beneficiary, {shouldEndEditing = false} = {}) {
    return {
        type: ActionType.BENEFICIARIES_SAVE,
        payload: beneficiary,
        meta: {shouldEndEditing},
    };
}

export function saveBeneficiarySuccess(beneficiary: Beneficiary, {shouldEndEditing = false} = {}) {
    return {
        type: ActionType.BENEFICIARIES_SAVE_SUCCESS,
        payload: beneficiary,
        meta: {shouldEndEditing},
    };
}

export function saveBeneficiaryFailed(beneficiary: Beneficiary, error?: Error | string) {
    return {
        type: ActionType.BENEFICIARIES_SAVE_FAILED,
        payload: beneficiary,
        error,
    };
}

export function saveBeneficiariesPaperwork(paperwork: Partial<BeneficiariesPaperwork>) {
    return {
        type: ActionType.BENEFICIARIES_SAVE_PAPERWORK,
        payload: paperwork,
    };
}

export function saveBeneficiariesPaperworkSuccess(paperwork: BeneficiariesPaperwork) {
    return {
        type: ActionType.BENEFICIARIES_SAVE_PAPERWORK_SUCCESS,
        payload: paperwork,
    };
}

export function saveBeneficiariesPaperworkFailed(paperwork: Partial<BeneficiariesPaperwork>, error?: Error | string) {
    return {
        type: ActionType.BENEFICIARIES_SAVE_PAPERWORK_FAILED,
        payload: paperwork,
        error,
    };
}

export function removeBeneficiary(id: string) {
    return {
        type: ActionType.BENEFICIARIES_REMOVE,
        payload: id,
    };
}

export function removeBeneficiarySuccess(id: string) {
    return {
        type: ActionType.BENEFICIARIES_REMOVE_SUCCESS,
        payload: id,
    };
}

export function removeBeneficiaryFailed(error: Error | string) {
    return {
        type: ActionType.BENEFICIARIES_REMOVE_FAILED,
        error,
    };
}

export function saveBeneficiaries() {
    return {
        type: ActionType.BENEFICIARIES_SAVE,
    };
}

export function saveBeneficiariesSuccess() {
    return {
        type: ActionType.BENEFICIARIES_SAVE_SUCCESS,
    };
}

export function saveBeneficiariesFailed(error: Error | string) {
    return {
        type: ActionType.BENEFICIARIES_SAVE_FAILED,
        error,
    };
}

export function cancelAllAddingOrEditing() {
    return {
        type: ActionType.BENEFICIARIES_CANCEL_ALL,
    };
}

export function startBeneficiaries() {
    return {
        type: ActionType.BENEFICIARIES_START,
    };
}

export function startBeneficiariesFailed(error: Error | string) {
    return {
        type: ActionType.BENEFICIARIES_START_FAILED,
        error,
    };
}

export function startBeneficiariesSuccess(paperwork: Paperwork) {
    return {
        type: ActionType.BENEFICIARIES_START_SUCCESS,
        payload: paperwork,
    };
}

export function confirmBeneficiaries() {
    return {
        type: ActionType.BENEFICIARIES_CONFIRM,
    };
}

export function confirmBeneficiariesSuccess(paperwork: Paperwork) {
    return {
        type: ActionType.BENEFICIARIES_CONFIRM_SUCCESS,
        payload: paperwork,
    };
}

export function confirmBeneficiariesFailed(error: Error | string) {
    return {
        type: ActionType.BENEFICIARIES_CONFIRM_FAILED,
        error,
    };
}

export function updateBeneficiaryInputValue(id: string, payoutPercentage: number) {
    return {
        type: 'beneficiaries/input_values/update',
        payload: {id, payoutPercentage},
    };
}
